<!-- 
  详情页 - 工单记录
  props:
    id: 详情id
    moduleName: 模块名
 -->

<template>
	<div class="work-order-log">
    <div v-if="!listData.length" class="empty">
      暂无数据
    </div>
		<ul v-else v-for="item in listData" :key="item.workOrderNo">
      <li class="item">
        <div class="item-left">
          <h3 class="title-name"><a href="javascript:;" @click="detail(item.id)">{{item.name}}</a></h3>
          <div>
            <p class="left-line"><span class="smalltitle">工单编号</span><span class="">:&nbsp;{{item.workOrderNo}}</span></p>
            <p class="left-line" v-if="item.customerName"><span class="smalltitle">客户名称</span><span>:&nbsp;{{item.customerName}}</span></p>
            <p class="left-line"><span class="smalltitle">负责人</span><span>:&nbsp;{{item.manager}}</span></p>
            <p class="left-line" v-if="item.state"><span class="smalltitle">工单阶段</span><span>:&nbsp;{{item.state}}</span></p>
            <p class="left-line"><span class="smalltitle">提交时间</span><span>:&nbsp;{{item.time}}</span></p>
            <p class="left-line" v-if="item.rateStar && item.rateStar >= 0"><span class="smalltitle">评价星级</span>:&nbsp;<el-rate class="rate-star" v-model="item.rateStar" disabled></el-rate></p>
          </div>
        </div>
        <div class="item-right">
          <p class="consumeTime" :class="{isOut: item.isOut === 1}">{{item.consumeTime}}</p>
          <p class="statusStr" 
          :class="'col-' + item.status">{{item.statusStr}}</p>
        </div>
      </li>
    </ul>
    
    <div class="load-more">
      <template v-if="showLoadmore">
        <i class="el-icon-loading"></i>
        加载更多
      </template>
      <template v-if="!showLoadmore && page.total>page.size">没有更多</template>
    </div>
	</div>
</template>

<script>
import * as api from 'src/api'
import * as common from 'src/config/common-config'

export default {
  props: {
    id: {
      type: Number
    },
    loading: {
      type: Number,
      default: 1
    },
    moduleName: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      listData: [],
      // 分页信息
      page: {
        size: 15,
        total: '',
        page: 1,
        rows: 1
      },
      moduleApi: common.moduleApi,
      isIng: true
    }
  },

  created () {
    this.getList()
  },

  computed: {
    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.size && this.page.rows > this.page.page) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {

    // 打开工单详情
    detail (id) {
      this.$emit('openDetail', 'workOrder', id)
    },

    getList () {
      let url = `/workOrder/listAjax.html`
      let params = {
        refId: this.id,
        page: this.page.page,
        pageSize: this.page.size,
        isApp: 0,
        refType: this.moduleApi[this.moduleName],
        belongerType: '0'
      }
      api.post(url, params, (data) => {
        this.page.total = data.pageHelper.rowsCount
        this.page.rows = data.pageHelper.pageTotal
        // 通过page.page来判断当前是刷新还是下拉加载更多
        if (this.page.page === 1) {
          this.listData = data.result.list
        } else {
          this.listData = this.listData.concat(data.result.list)
        }
      })
    },
    // 加载更多
    loadmore () {
      this.page.page++
      this.getList()
    }
  },
  watch: {
    loading () {
      if (this.page.rows > this.page.page) {
        this.loadmore()
      }
    }
  }
}
</script>

<style lang="less">
.work-order-log {
  .rate-star {
    display: inline-block;
    .el-rate__item {
      .el-rate__icon {
        font-size: 13px!important;
      }
    }
  }
}
</style>
<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .work-order-log {
    padding-top: 4px;
    .item {
      display: flex;
      padding: 20px 15px 20px 30px;
      margin-bottom: 20px;
      box-shadow: 0px 0px 8px #b4b4b4;
      border-radius: 6px;
      .item-left {
        flex: 1;
        background: white;
        .title-name {
          color: #5697F2;
          font-size: 15px;
          font-weight: bold;
          margin-bottom: 15px;
        }
        .left-line {
          margin-bottom: 6px;
          .smalltitle {
            display: inline-block;
            width: 70px;
            font-size: 14px;
            color: #929292;
          }
        }
      }
      .item-right {
        flex: 0 0 auto;
        .consumeTime {
          margin-bottom: 28px;
        }
        .isOut {
          color: #FF6360;
        }
        .statusStr {
          text-align: right;
          font-size: 15px;
        }
        .col-0 {
           color: #5E97F6;
        }
        .col-3,.col-4 {
          color: #ff6161;
        } 
        .col-1,.col-5 {
          color: #5a97f6;
        }
        .col-2 {
          color: #13ce66;
        }        
      }

    }
    .empty {
      line-height: 3;
      text-align: center;
    }
  }
  
</style>


// WEBPACK FOOTER //
// work-order-log.vue?6a3fa39d